import { When } from 'react-if';
import { ICON_COLOR, SchoolFillIcon } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { type DisplayTextItems } from '../types';
import { PublisherTextDisplay } from './PublisherTextDisplay';
import { SchoolInfoTextDisplay } from './SchoolInfoTextDisplay';
import { SubjectTextDisplay } from './SubjectTextDisplay';
interface CategoryTextDisplayViewProps {
  /** 생성된 표시 텍스트 파트들 */
  displayItems: DisplayTextItems;
}

/**
 * 카테고리 정보 호버 프리뷰 UI 컴포넌트
 *
 * 실제 선택된 값과 호버 시 임시 값을 병합한 표시 텍스트를 표시합니다.
 *
 * 책임:
 * - 표시 텍스트 렌더링
 * - 실제 값과 프리뷰 값의 시각적 구분 (색상)
 *
 * 상태 관리는 useCategoryDisplayText hook에서 담당합니다.
 */
export const CategoryTextDisplayView = ({
  displayItems
}: CategoryTextDisplayViewProps) => {
  const {
    t
  } = useTranslation(['build']);
  return <div className="flex h-[56px] w-full items-center gap-xs rounded-sm bg-alternative px-sm text-heading-sm-bold" data-sentry-component="CategoryTextDisplayView" data-sentry-source-file="CategoryTextDisplayView.tsx">
      <SchoolFillIcon size="md" fill={ICON_COLOR.disabled} data-sentry-element="SchoolFillIcon" data-sentry-source-file="CategoryTextDisplayView.tsx" />
      <div>
        <When condition={Object.values(displayItems).length > 0} data-sentry-element="When" data-sentry-source-file="CategoryTextDisplayView.tsx">
          <SchoolInfoTextDisplay displayItems={displayItems} data-sentry-element="SchoolInfoTextDisplay" data-sentry-source-file="CategoryTextDisplayView.tsx" />
          <SubjectTextDisplay displayItems={displayItems} data-sentry-element="SubjectTextDisplay" data-sentry-source-file="CategoryTextDisplayView.tsx" />
          <PublisherTextDisplay displayItems={displayItems} data-sentry-element="PublisherTextDisplay" data-sentry-source-file="CategoryTextDisplayView.tsx" />
        </When>
        <When condition={Object.values(displayItems).length === 0} data-sentry-element="When" data-sentry-source-file="CategoryTextDisplayView.tsx">
          <span className="text-disabled">
            {t('build.category.selectAllRequiredInfo')}
          </span>
        </When>
      </div>
    </div>;
};